exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".users-sell-out .totals[data-v-1ac32566] {\n  background-color: #f5f5f5;\n  padding: 10px 20px;\n  color: #868e96;\n  font-weight: 500;\n  font-size: 14px;\n}\n.users-sell-out[data-v-1ac32566] .title {\n  font-size: 16px;\n  color: #3e6873;\n  padding: 16px 0 0 16px;\n}\n.users-sell-out .product-details[data-v-1ac32566] {\n  min-height: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);

// exports
